import React from 'react';

import { makeStyles, withStyles } from '@material-ui/core';

import ReactMarkdown, { ReactMarkdownProps } from 'react-markdown';
import { componentBorderColor, fontFamily, darkColor, contrastColor } from '../theme/component.setup';

const useStyles = makeStyles({
  table: {
    overflow: 'auto',
  }
});

function MarkdownTable(props: { children: React.ReactNode }) {
  const classes = useStyles();
  return <div className={classes.table}>
    <table>{props.children}</table>
  </div>;
}

export const Markdown = withStyles((theme) => ({
  md: {
    '& code': {
      color: componentBorderColor,
    },
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      fontFamily: fontFamily,
    },
    '& thead > tr': {
      color: componentBorderColor,
      backgroundColor: darkColor,
      textAlign: 'left',
    },
    '& tbody > tr:nth-child(2n)': {
      backgroundColor: contrastColor,
    },
    '& th': {
      padding: `${theme.spacing(1)}px ${theme.spacing(5)}px`,
    },
    '& td': {
      padding: `${theme.spacing(1)}px ${theme.spacing(5)}px`,
    },
  },
}))(({ classes, ...props }: ReactMarkdownProps & { classes: Record<"md", string> }) =>
  <ReactMarkdown
    className={classes.md}
    renderers={{
      'table': MarkdownTable
    }}
    {...props}
  >
  </ReactMarkdown>
);

